import {createAsyncThunk} from '@reduxjs/toolkit';
import {ApiLeasingCalculatorCodes} from 'modules/api';

export const fetchLeasingCalculatorCodes = createAsyncThunk(
  'codes/leasingCalculator',
  async (_, { rejectWithValue }) => {
    try {
      const response =
        await ApiLeasingCalculatorCodes.getCombinedLeasingCalculatorCodes();
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const fetchLeasingCalculatorGeneralDataCodes = createAsyncThunk(
  'codes/leasingCalculatorGeneralDataCodes',
  async (_, { rejectWithValue }) => {
    try {
      const response = await ApiLeasingCalculatorCodes.getGeneralDataCodes();
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const fetchCombinedLeasingObjectTypesAndMakes = createAsyncThunk(
  'codes/leasingObjectTypesAndMakes',
  async (_, { rejectWithValue }) => {
    try {
      const response =
        await ApiLeasingCalculatorCodes.getCombinedLeasingObjectTypesAndMakes();
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const fetchCombinedLeasingObjectDataByMake = createAsyncThunk(
  'codes/leasingObjectDataByMake',
  async (makeId: number, { rejectWithValue }) => {
    try {
      const response =
        await ApiLeasingCalculatorCodes.getCombinedLeasingObjectDataByMake(
          makeId,
        );
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const fetchCalculatorRemainingValue = createAsyncThunk(
    'codes/restValues',
    async (request: any, { rejectWithValue }) => {
        try {
            return await ApiLeasingCalculatorCodes.getCalculatorRemainingValue(
                request,
            );
        } catch (err) {
            return rejectWithValue(err);
        }
    },
);
